"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MyInformation = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../models");
var _FormattedMessage = require("../FormattedMessage");
var _skeletons = require("../skeletons");
var _MyInformationContent = require("./MyInformationContent");
var _styles = require("./styles");
var _useMyInformation = require("./useMyInformation");
var _jsxRuntime = require("react/jsx-runtime");
const MyInformation = () => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    myInformationContentProps,
    isQueryLoading
  } = (0, _useMyInformation.useMyInformation)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.MyInformationWrapper, {
    ...getTestIdProps(_models.TestId.MyInformation),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.SectionHeader, {
      ...getTestIdProps(_models.TestId.MyInformationHeader),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        variant: "h6",
        ...getTestIdProps(_models.TestId.MyInformationTitle),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
          id: "myInformation"
        })
      })
    }), isQueryLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_skeletons.MyInformationSkeleton, {}) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_MyInformationContent.MyInformationContent, {
      ...myInformationContentProps
    })]
  });
};
exports.MyInformation = MyInformation;